<template>
  <div class="widget-wrap">
    <div class="block-header clearfix">
      <ul class="nav flex-column small-bar">
        <li>
          <div class="pointer small-item" @click="goFinance()" v-bind:class="{active: path_name == 'finance_list'}">
            <span class="list-label">收支管理</span>
          </div>
          <hr>
          <div class="pointer small-item" @click="goFixedMoney()" v-bind:class="{active: path_name == 'fixed_money'}">
            <span class="list-label">固定收支</span>
          </div>
          <div class="pointer small-item" @click="goMoneyCategories()" v-bind:class="{active: path_name == 'money_categories'}">
            <span class="list-label">分類管理</span>
          </div>
          <div class="pointer small-item" @click="goYearBudget()" v-bind:class="{active: path_name == 'year_budget'}">
            <span class="list-label">年度預算</span>
          </div>
          <hr>
          <div class="pointer small-item" @click="goIncomeStatement()" v-bind:class="{active: path_name == 'income_statement'}">
            <span class="list-label">損益表</span>
          </div>
          <div class="pointer small-item" @click="goCashFlowHistory()" v-bind:class="{active: path_name == 'cashflow_history'}">
            <span class="list-label">現金餘額明細</span>
          </div>
          <div class="pointer small-item" @click="goCashFlow()" v-bind:class="{active: path_name == 'cashflow'}">
            <span class="list-label">現金流量表</span>
          </div>
          <div class="pointer small-item" @click="goCashFlowEstimate()" v-bind:class="{active: path_name == 'cashflow_estimate'}">
            <span class="list-label">現金流預估</span>
          </div>
        </li>    
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'small-bar',
  data() {
    return {
      path_name: this.$route.name,
    }
  },
  created() {
    
  },
  props: ['toggle_aside'],
  computed: {
    
  },
  methods: {
    goFinance(){
      this.$router.push({ name: 'finance_list'})
    },
    goFixedMoney(){
    	this.$router.push({ name: 'fixed_money'})
    },
    goMoneyCategories(){
    	this.$router.push({ name: 'money_categories'})
    },
    goYearBudget(){
    	this.$router.push({ name: 'year_budget'})
    },
    goIncomeStatement(){
    	this.$router.push({ name: 'income_statement'})
    },
    goCashFlow(){
    	this.$router.push({ name: 'cashflow'})
    },
    goCashFlowEstimate(){
    	this.$router.push({ name: 'cashflow_estimate'})
    },
    goCashFlowHistory(){
    	this.$router.push({ name: 'cashflow_history'})
    }
  },
}
</script>


// WEBPACK FOOTER //
// SmallBar.vue?38fe59cf